<template>
    <div class="flex items-center relative">
        <input
            :id="id"
            type="checkbox"
            :value="value"
            :disabled="disabled"
            :checked="isChecked"
            @change="toggleValue"
            class="peer hidden"
        />
        <label
            :for="id"
            class="min-w-4 min-h-4 border bg-grayBg border-gray-300 rounded-sm cursor-pointer
             relative flex items-center justify-center text-black text-xs font-bold
             transition-colors duration-300
             peer-checked:bg-baseColor peer-checked:border-baseColor"
        >
            <transition
                enter-active-class="transition duration-150 ease-out transform"
                enter-from-class="translate-y-2 opacity-0"
                enter-to-class="translate-y-0 opacity-50"
                leave-active-class="transition duration-100 ease-in transform"
                leave-from-class="translate-y-0 opacity-50"
                leave-to-class="translate-y-2 opacity-0"
            >
                <IconCheckMark v-if="isChecked" class="w-3 h-3 text-black" />
            </transition>
        </label>
        <div class="ml-2">
            <slot />
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import IconCheckMark from "@js/components/Icons/IconCheckMark.vue";

const props = defineProps({
    id: String,
    value: [String, Number, Boolean],
    // Разрешаем разные типы и даём дефолт, чтобы не было undefined
    modelValue: {
        type: [Array, Boolean, String, Number, Object],
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["update:modelValue"]);

const isArrayModel = computed(() => Array.isArray(props.modelValue));

const isChecked = computed(() => {
    if (isArrayModel.value) {
        // Осторожно с типами: убедись, что в сторе и value один тип (оба Number или оба String)
        return props.modelValue.includes(props.value);
    }
    // Для bool — просто true/false, для скаляров — считаем checked, если truthy
    if (typeof props.modelValue === "boolean") return props.modelValue;
    return !!props.modelValue;
});

function toggleValue(e) {
    if (props.disabled) return;

    const checked = e.target.checked;

    if (isArrayModel.value) {
        const next = Array.isArray(props.modelValue) ? [...props.modelValue] : [];
        const idx = next.indexOf(props.value);
        if (checked && idx === -1) next.push(props.value);
        if (!checked && idx !== -1) next.splice(idx, 1);
        emit("update:modelValue", next);
        return;
    }

    if (typeof props.modelValue === "boolean") {
        emit("update:modelValue", !props.modelValue);
        return;
    }

    // Одиночное значение (строка/число): устанавливаем value если checked, иначе null/''.
    emit("update:modelValue", checked ? props.value : (typeof props.modelValue === "string" ? "" : null));
}
</script>
